<template>
  <!-- 사진촬영 허가 신청 -->
  <div>
    <v-card class="ma-4 word_keeper">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold" style="min-width:140px;">
          <v-icon class="mr-2">mdi-square-edit-outline</v-icon>사진촬영 허가 신청
        </v-toolbar-title>
      </v-toolbar>
      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          SK 스페셜티 담당자
        </v-card-subtitle>
      </v-toolbar>
      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <div class="d-flex">
                <v-text-field v-model="zChargeInfo.cEmailAddr1" @keyup="ResetEmailInfo()" @keyup.enter="GetChargeInfo()" class="mr-2" dense persistent-placeholder>
                  <template v-slot:label>
                    담당자 이메일<strong class="red--text">*</strong>
                  </template>
                </v-text-field>
                <v-select v-model="zChargeInfo.cEmailAddr2" :items="zEmaillAddr" @click:append-outer="GetChargeInfo()" append-outer-icon="search" auto-select-first dense style="width:160px;">
                  <template v-slot:prepend>
                    <div>@</div>
                  </template>
                </v-select>
              </div>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-text-field v-model="zChargeInfo.cUserNm" readonly label="담당자 이름" dense persistent-placeholder></v-text-field>
            </v-col>
            <!-- <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="zChargeInfo.cUserNm" @keyup.enter="ShowDialog()" @click:append-outer="ShowDialog()" append-outer-icon="search" dense persistent-placeholder>
                <template v-slot:label>
                  담당자 이름<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col> -->
          </v-row>
        </v-card-text>
      </v-card>


      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          촬영자 정보
        </v-card-subtitle>
      </v-toolbar>
      <v-card outlined tile class="ma-4">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.CustomNm" label="촬영자명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-if="CustomInfo.Local == 'Y'" v-model="CustomInfo.CorpNmKor" label="소속 업체명" dense disabled persistent-placeholder></v-text-field>
              <v-text-field v-else v-model="CustomInfo.CorpNmEng" label="소속 업체명" dense disabled persistent-placeholder></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="CustomInfo.Tel" label="휴대전화번호" dense disabled persistent-placeholder></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card outlined tile class="ma-4 essetial_card">
        <v-card-text class="pt-6 pb-0">
          <v-row class="mb-0">
            <v-col cols="12" sm="6" md="3">
              <IronDate ref="IronDateRef" v-model="editedItem.sNowSelectDate" @update="onDateRangeChange" @overmaxperiod="overmaxperiod" cLabelEs="촬영기간" :sMinDate="sToday" style="width:100%"/>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-text-field v-model="editedItem.cZone" @click:append-outer="ShowMapDialog()" append-outer-icon="map" dense readonly persistent-placeholder>
                <template v-slot:label>
                  촬영장소<strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <v-select v-model="editedItem.cPurpose" :items="zPicPurpose" dense persistent-placeholder>
                <template v-slot:label>
                  <div>촬영목적<strong class="red--text">*</strong></div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="editedItem.cInfo" dense auto-grow rows="1" persistent-placeholder>
                <template v-slot:label>
                  <div>촬영내용<strong class="red--text">*</strong></div>
                </template>
              </v-textarea>
            </v-col>
            <v-col cols="4" sm="2" md="2">
              보안서약<strong class="red--text">*</strong>
            </v-col>
            <v-col cols="8" sm="10" md="10" class="caption text-sm-subtitle-2">
              <p class="mb-0">상기 신청 내용에 한하여 촬영하고, 반·출입 절차를 준수하겠으며, 회사정보의 무단 반출 등으로 인한
                <span class="red--text">일체의 책임</span>은
                <span class="red--text">신청인에게 있음</span>에 동의합니다.
              </p>
              <v-checkbox v-model="bAgree" style="max-width:120px;" class="ml-0" dense color="black">
                <template v-slot:label>
                  <div class="black--text">
                    동의함
                  </div>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

        
      <v-divider class="mr-4 ml-4"></v-divider>
      <v-toolbar dense flat color="white" class="text-truncate">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          촬영장치
        </v-card-subtitle>
      </v-toolbar>
      <div class="grey lighten-3 caption text-sm-subtitle-2 grey--text text--darken-2 ma-4 mb-8 pa-4">
        ※ 촬영기기 및 부속장치를 등록 하시고, 품명, 시리얼번호, 저장용량, 수량 등의 일치하지 않을 경우 반·출입이 불허될 수 있습니다. 또한 휴대전화을 촬영기기로 신청할 수 없습니다.
      </div>
      <v-divider class="mr-2 ml-2 mt-2"></v-divider>
      <v-toolbar dense flat color="white" class="text-truncate">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          촬영기기
        </v-card-subtitle>
        <v-spacer></v-spacer>
        <v-btn @click="AddRow(1)" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
      </v-toolbar>
      <!-- 촬영 기기 등록 테이블 -->
      <v-data-table
        :items="zReqPicDeviceInfo"
        :headers="headers"
        :hide-default-footer="true"
        class="ml-2 mr-2 "
        disable-sort
      >
        <template v-slot:header.cProductNm="{ }">
          <div>품명<strong class="ml-1 red--text">*</strong></div>
        </template>
        <template v-slot:header.cSerialNum="{ }">
          <div>시리얼넘버<strong class="ml-1 red--text">*</strong></div>
        </template>
        <template v-slot:header.cVolume="{ }">
          <div>용량<strong class="ml-1 red--text">*</strong></div>
        </template>
        <template v-slot:header.cCount="{ }">
          <div>수량(개)<strong class="ml-1 red--text">*</strong></div>
        </template>
        <template v-slot:item.cProductNm="{ item }">
          <v-text-field v-model="item.cProductNm" dense></v-text-field>
        </template>
        <template v-slot:item.cSerialNum="{ item }">
          <v-text-field v-model="item.cSerialNum" dense></v-text-field>
        </template>
        <template v-slot:item.cVolume="{ item }">
          <v-text-field v-model="item.cVolume" dense></v-text-field>
        </template>
        <template v-slot:item.cCount="{ item }">
          <v-text-field v-model="item.cCount" type='number' dense></v-text-field>
        </template>
        <template v-slot:item.cDel="{ item }">
          <v-icon @click="DelRow(1,item)" color="black">mdi-close</v-icon>
        </template>
        <template v-slot:no-data>
          <div class="black--text">촬영기기를 등록하여 주세요</div>
        </template>
      </v-data-table>


      <v-divider class="mr-2 ml-2 mt-2"></v-divider>
      <v-toolbar dense flat color="white">
        <v-card-subtitle class="text-subtitle-1 grey--text text--darken-2 font-weight-bold pa-0">
          저장매체
        </v-card-subtitle>
        <v-spacer></v-spacer>
        <v-btn @click="AddRow(2)" class="font-weight-bold" small dark width="70px"><v-icon small class="mr-1">mdi-plus</v-icon><div class="text-caption">추가</div></v-btn>
      </v-toolbar>
      <!-- 저장매체 등록 테이블 -->
      <v-data-table
        :items="zReqPicSaveInfo"
        :headers="headers1"
        :hide-default-footer="true"
        class="ml-2 mr-2"
      >
        <template v-slot:item.cProductNm="{ item }">
          <v-text-field v-model="item.cProductNm" dense></v-text-field>
        </template>
        <template v-slot:item.cSerialNum="{ item }">
          <v-text-field v-model="item.cSerialNum" dense></v-text-field>
        </template>
        <template v-slot:item.cVolume="{ item }">
          <v-text-field v-model="item.cVolume" dense></v-text-field>
        </template>
        <template v-slot:item.cCount="{ item }">
          <v-text-field v-model="item.cCount" type="number" dense></v-text-field>
        </template>
        <template v-slot:item.cDel="{ item }">
          <v-icon @click="DelRow(2,item)" color="black">mdi-close</v-icon>
        </template>
        <template v-slot:no-data>
          <div class="black--text">저장매체를 등록하여 주세요</div>
        </template>
      </v-data-table>
      <v-card-text align="center">
        <v-divider class="ma-4 mr-0 ml-0"></v-divider>
        <v-btn @click="$router.push({name: 'MainBoard'});" text class="mr-2"><v-icon class="mr-2">dashboard</v-icon>홈</v-btn>
        <v-btn @click="SetPhotoPerLog('')" dark class="ml-2" width="100px"><v-icon class="mr-2">post_add</v-icon>신청</v-btn>
      </v-card-text>
    </v-card>

    <MapDialog ref="MapDialogRef" @SetMap="SetMap"/>
  </div>
</template>

<script>
import BasicInfo from "../BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import { mapState } from "vuex";
import IronDate from '@/components/iron28Calendar/src/IronDate5.vue';
import Util from "../Util.js";

import MapDialog from "../components/MapDialog.vue";

export default {
  components: {
    IronDate,
    MapDialog,
  },

  data: () => ({
    bAgree : false,
    sToday : new Date(),
    zReqPicDeviceInfo : [{cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",}],
    // zdefaultReqPicDeviceInfo : [{cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",}],
    zReqPicSaveInfo : [{cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",}],
    zdefaulDevice : [{cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",}],
    zdefaulSave : [{cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",}],

    zMapZoneInfo : [],
    headers: [
      { text: '품명 *', align: 'start', value: 'cProductNm',},
      { text: '시리얼넘버 *', value: 'cSerialNum' },
      { text: '용량 *', value: 'cVolume' },
      { text: '수량(개) *', value: 'cCount' },
      { text: '삭제', value: 'cDel' },
    ],
    headers1: [
      { text: '품명', align: 'start', value: 'cProductNm',},
      { text: '시리얼넘버', value: 'cSerialNum' },
      { text: '용량', value: 'cVolume' },
      { text: '수량(개)', value: 'cCount' },
      { text: '삭제', value: 'cDel' },
    ],
    editedItem :{
      cPurpose : "0",
      cZone    : "",
      cInfo    : "",
      sNowSelectDate : Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
      sStartDate : Util.sFormatDate(Date()),
      sEndDate : Util.sFormatDate(Util.sTomorrowSel()),
    },

    defaultItem :{
      cPurpose : "0",
      cZone    : "",
      cInfo    : "",
      sNowSelectDate : Util.sFormatDate(Date()) + " ~ " +  Util.sFormatDate(Util.sTomorrowSel()),
      sStartDate : Util.sFormatDate(Date()),
      sEndDate : Util.sFormatDate(Util.sTomorrowSel()),
    },

    zChargeInfo : {
      cUserId: "",
      cUserNm :  "",
      cEmailAddr1 : "",
      cEmailAddr2 : "",
    },
  }),

  computed: {
    ...mapState(["CustomInfo","zPicPurpose","zEmaillAddr"]),
  },

  created() {
  },

  mounted() {
    this.init();
  },

  methods : {
    init() {
      this.editedItem  = Object.assign({}, this.defaultItem);
      
      this.zReqPicDeviceInfo  = [];
      this.zReqPicSaveInfo  = [];

      this.zReqPicDeviceInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});
      this.zReqPicSaveInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});

      this.zMapZoneInfo = [];
      this.bAgree = false;

      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
      this.zChargeInfo.cEmailAddr1 = ""
      this.zChargeInfo.cEmailAddr2 = this.zEmaillAddr[0]
    },

    // 맵선택 다이올로그창 열기
    ShowMapDialog(){
      this.$refs.MapDialogRef.ShowDialog(this.zMapZoneInfo)
    },

    // 맵선택 후 정보 가져오기
    SetMap(zZone,zZoneNm){
      this.zMapZoneInfo = zZone
      this.editedItem.cZone = zZoneNm
    },

    ResetEmailInfo(){
      this.zChargeInfo.cUserId = ""
      this.zChargeInfo.cUserNm = ""
    },

    GetChargeInfo(){
      var posData = {
        CustomId : this.CustomInfo.CustomId,
        Email : this.zChargeInfo.cEmailAddr1 + "@" +this.zChargeInfo.cEmailAddr2,
      };

      axios
        .post(BasicInfo.UIL_API + "GetChargeInfo", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length == 0) {
              EventBus.$emit("onShowMsgBox","입력하신 이메일을 다시 확인하여 주세요.","입력하신 이메일과 일치하는 담당자가 없습니다.");
            } else {
              this.zChargeInfo.cUserId = res.data.Result[0].cUserId
              this.zChargeInfo.cUserNm = res.data.Result[0].cUserNm
            }
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },

    overmaxperiod(value){
      EventBus.$emit("onShowMsgBox", value.sTitle,value.sMsg);
    },

    // 날짜 변경하기
    onDateRangeChange(daterange){
      this.editedItem.sStartDate = Util.sFormatDate(daterange.startDate);
      this.editedItem.sEndDate = Util.sFormatDate(daterange.endDate);      
      this.editedItem.sNowSelectDate = this.editedItem.sStartDate + " ~ " +  this.editedItem.sEndDate;           
    },

    // 열 추가하기
    AddRow(state) {
      if (state == 1){
        this.zReqPicDeviceInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});
      } else {
        this.zReqPicSaveInfo.push({cProductNm: "", cSerialNum: "", cVolume: "", cCount: "",});
      }
    },

    // 열 삭제하기
    DelRow(state,row) {
      if (state == 1){
        let iDelIndex1 = this.zReqPicDeviceInfo.indexOf(row);
        if (iDelIndex1 != -1) {  
          this.zReqPicDeviceInfo.splice(iDelIndex1, 1);
        }
      } else {
        let iDelIndex2 = this.zReqPicSaveInfo.indexOf(row);
        if (iDelIndex2 != -1) {  
          this.zReqPicSaveInfo.splice(iDelIndex2, 1);
        }
      }
    },

    // 사진촬영 허가 신청하기
    SetPhotoPerLog(sPhotoPerId){
      if (this.zChargeInfo.cUserId == ""){
        EventBus.$emit("onShowMsgBox", "담당자가 선택 되지 않았습니다.","검색 아이콘을 클릭 하여 담당자를 검색 및 선택하여 주세요.");
        return
      }

      if (this.editedItem.cZone == ""){
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "촬영 장소를 선택하여 주세요.");
        return
      }

      if (this.editedItem.cPurpose == null){
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "촬영 목적을 선택하여 주세요.");
        return
      }

      if (this.editedItem.cInfo == ""){
        EventBus.$emit("onShowMsgBox", "필수 선택 사항이 누락되었습니다.", "촬영 내용을 입력하여 주세요.");
        return
      }

      if (this.bAgree == false){
        EventBus.$emit("onShowMsgBox","보안서약에 대한 동의","보안서약에 동의해 주세요.");
        return
      }

      if (this.zReqPicDeviceInfo.length == 0){
        EventBus.$emit("onShowMsgBox","촬영장치에 대한 정보가 누락되었습니다.","촬영장치를 추가하여 주세요.");
        return
      }

      for (let i=0; i < this.zReqPicDeviceInfo.length; i++) {
        if (this.zReqPicDeviceInfo[i].cProductNm == "") {
          EventBus.$emit("onShowMsgBox","촬영장치 항목 중 품명 항목이 누락되었습니다.",  "품명 항목을 입력하여 주세요.");
          return
        }
        if (this.zReqPicDeviceInfo[i].cSerialNum == "") {
          EventBus.$emit("onShowMsgBox","촬영장치 항목 중 시리얼 넘버 항목이 누락되었습니다.",  "시리얼 넘버 항목을 입력하여 주세요.");
          return
        }
        if (this.zReqPicDeviceInfo[i].cVolume == "") {
          EventBus.$emit("onShowMsgBox","촬영장치 항목 중 용량 항목이 누락되었습니다.",  "용량 항목을 입력하여 주세요.");
          return
        }
        if (this.zReqPicDeviceInfo[i].cCount == "") {
          EventBus.$emit("onShowMsgBox","촬영장치 항목 중 수량(개) 항목이 누락되었습니다.",  "수량(개) 항목을 입력하여 주세요.");
          return
        }
      }

      var posData = {
        PhotoPerId : sPhotoPerId,
        CustomId : this.CustomInfo.CustomId,
        CustomNm : this.CustomInfo.CustomNm,
        CorpId : this.CustomInfo.CorpId,
        CorpNm : Util.ChangeCorpNm3Data(this.CustomInfo.Local,this.CustomInfo.CorpNmKor,this.CustomInfo.CorpNmEng),
        UserId : this.zChargeInfo.cUserId,
        // ChargeEmail : this.zChargeInfo.cEmail,
        ChargeEmail : this.zChargeInfo.cEmailAddr1 + "@" +this.zChargeInfo.cEmailAddr2,
        StartDate : this.editedItem.sStartDate,
        EndDate : this.editedItem.sEndDate,
        Purpose : this.editedItem.cPurpose,
        Info : this.editedItem.cInfo,
        Zone : this.editedItem.cZone,
        MapTreeInfo : Util.ChangeArray(this.zMapZoneInfo),
        ReqPicDeviceInfo : this.zReqPicDeviceInfo,
        ReqPicSaveInfo : this.zReqPicSaveInfo,
      };

      axios
        .post(BasicInfo.UIL_API + "SetPhotoPerLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.init();
            EventBus.$emit("onShowMsg",false,  "사진촬영 허가 요청이 완료되었습니다.");
          } else if (res.data.ResultCd == "55") {
            EventBus.$emit("onShowMsgBox","출입 정지 기간 중입니다.", res.data.Msg);
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);        
        });
    },
  }
}
</script>

<style>
</style>